// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"338":"223790ab","787":"88a51963","881":"4b19bd26"}[chunkId] + ".chunk.js";
};